import { RootState } from "../../rootState";

export const mapOptionsSelector = (state: RootState) => state.mapInitialConfig && state.mapInitialConfig.mapOptions;

export const workspaceModeSelector = (state: RootState) =>
    mapOptionsSelector(state) && state.mapInitialConfig.mapOptions.workspaceMode;

export const defaultChangeTypesSelector = (state: RootState) =>
    mapOptionsSelector(state) &&
    mapOptionsSelector(state).changes &&
    mapOptionsSelector(state).changes.defaultChangeTypes;

export const featureInfoCountSelector = (state: RootState) =>
    mapOptionsSelector(state) && state.mapInitialConfig.mapOptions.featureInfoCount;

export const gisServerUrlSelector = (state: RootState) => state.layerOptions.gisServerUrl;
export const wizardPortalUrlSelector = (state: RootState) => state.wizardPortalSettings.url;

export const geoCalcOptionsSelector = (state: RootState) =>
    mapOptionsSelector(state) && state.mapInitialConfig.mapOptions.geoCalc;
export const geoCalcStyleSelector = (state: RootState) =>
    geoCalcOptionsSelector(state) && state.mapInitialConfig.mapOptions.geoCalc.style;
export const geoCalcEnabledSelector = (state: RootState) =>
    geoCalcOptionsSelector(state) && geoCalcOptionsSelector(state).enabled;
export const editedFeatureStyleSelector = (state: RootState) =>
    mapOptionsSelector(state) &&
    mapOptionsSelector(state).editFeature &&
    mapOptionsSelector(state).editFeature.editedFeatureStyle;
export const layersContainerExpandedSelector = (state: RootState) =>
    mapOptionsSelector(state) &&
    mapOptionsSelector(state).layersContainer &&
    mapOptionsSelector(state).layersContainer.expanded;

export const featureFilterEnabledSelector = (state: RootState) =>
    mapOptionsSelector(state) &&
    mapOptionsSelector(state).featureFilter &&
    mapOptionsSelector(state).featureFilter.enabled;
export const changesEnabledSelector = (state: RootState) =>
    mapOptionsSelector(state) && mapOptionsSelector(state).changes && mapOptionsSelector(state).changes.enabled;
export const wfsMaxFeatureCountSelector = (state: RootState) =>
    mapOptionsSelector(state) && mapOptionsSelector(state).wfsMaxFeatureCount;
export const wfs3dRouteSelector = (state: RootState) =>
    mapOptionsSelector(state) && mapOptionsSelector(state).wfs3d && mapOptionsSelector(state).wfs3d.route;

export const isFooterEnabled = (state: RootState) =>
    mapOptionsSelector(state) && mapOptionsSelector(state).footer?.enabled;

export const dataSetFilterSelector = (state: RootState) =>
    mapOptionsSelector(state) && mapOptionsSelector(state).dataSetFilter;

export const isArcModeEnabledSelector = (state: RootState) => mapOptionsSelector(state)?.arc?.enabled;

export const dataTypeSelector = (state: RootState) => mapOptionsSelector(state).dataType;
